import React from 'react'

import SlideInner from '../SlideInner/SlideInner'
import styles from './LandingStronghold.scss'
import {
    LANDING_STRONGHOLD_HEADER,
    LANDING_STRONGHOLD_MESSAGE1,
    LANDING_STRONGHOLD_MESSAGE2,
} from './translations'

const LandingStronghold = () => {
    return (
        <SlideInner
            title={LANDING_STRONGHOLD_HEADER}
            description={[LANDING_STRONGHOLD_MESSAGE1, LANDING_STRONGHOLD_MESSAGE2]}
        >
            <div className={styles.imageContainer}/>
        </SlideInner>
    )
}

export default LandingStronghold


// WEBPACK FOOTER //
// ./containers/Landing/components/LandingStronghold/LandingStronghold.jsx